function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 59.5,
  cy: 59.5,
  r: 59.5,
  fill: "#8247E5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M78.375 47.182c-1.313-.752-3-.752-4.5 0l-10.5 6.206-7.125 3.95-10.313 6.205c-1.312.753-3 .753-4.5 0l-8.062-4.89c-1.313-.752-2.25-2.256-2.25-3.948V45.3c0-1.504.75-3.009 2.25-3.949l8.063-4.701c1.312-.753 3-.753 4.5 0L54 41.54c1.313.752 2.25 2.256 2.25 3.949v6.206l7.125-4.138v-6.394c0-1.504-.75-3.009-2.25-3.95l-15-8.838c-1.313-.752-3-.752-4.5 0L26.25 37.403c-1.5.752-2.25 2.257-2.25 3.761v17.678c0 1.504.75 3.009 2.25 3.95l15.188 8.838c1.312.752 3 .752 4.5 0l10.312-6.018 7.125-4.137 10.313-6.018c1.312-.752 3-.752 4.5 0l8.062 4.701c1.313.752 2.25 2.257 2.25 3.95v9.402c0 1.505-.75 3.01-2.25 3.95l-7.875 4.701c-1.313.752-3 .752-4.5 0l-8.063-4.701c-1.312-.752-2.25-2.257-2.25-3.95v-6.017l-7.124 4.137v6.206c0 1.504.75 3.009 2.25 3.95l15.187 8.838c1.313.752 3 .752 4.5 0l15.188-8.839c1.312-.752 2.25-2.257 2.25-3.95V59.97c0-1.504-.75-3.009-2.25-3.95l-15.188-8.838z",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(24 28)",
  d: "M0 0h72v63H0z"
})));

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.a8966c2b.svg";
export { ForwardRef as ReactComponent };